import React from "react";

import { Grid } from "@mui/material";
import { ColorsColumn } from "@src/components/ColorAndStyle/sections/components/ColorsColumn";

import { useColorConfiguration } from "../../hooks/use-color-configuration";
import { BaseColorWrapperProps } from "../../types";
import {
  getProgressBarBarFields,
  getProgressBarBreakpointFields,
  getProgressBarTextColorFields,
} from "../../utils/fields";

import { ColorThemeHeader } from "./ColorThemeHeader";

export const ProgressBarColorsWrapper = ({
  widgetType,
  colorTheme,
  onColorChange,
  offer,
  widget,
  quantityButtonVariant,
}: BaseColorWrapperProps) => {
  const { getPrimaryColor, colorFieldsConfig } = useColorConfiguration({
    widgetType,
    colorTheme,
    widget,
    quantityButtonVariant,
    offer,
  });

  const breakpointColorSection =
    getProgressBarBreakpointFields(colorFieldsConfig);
  const barColorSection = getProgressBarBarFields(colorFieldsConfig);
  const textColorSection = getProgressBarTextColorFields(colorFieldsConfig);

  return (
    <Grid item container spacing={3}>
      <ColorThemeHeader
        primaryColor={getPrimaryColor()}
        onColorChange={onColorChange}
      />
      <ColorsColumn
        widgetType={widgetType}
        colorFields={breakpointColorSection.colorFields}
        sectionTitle={breakpointColorSection.sectionTitle}
        onColorChange={onColorChange}
        xs={3}
      />
      <ColorsColumn
        widgetType={widgetType}
        colorFields={barColorSection.colorFields}
        sectionTitle={barColorSection.sectionTitle}
        onColorChange={onColorChange}
        xs={3}
      />
      <ColorsColumn
        colorFields={textColorSection.colorFields}
        onColorChange={onColorChange}
        sectionTitle={"Dynamic Progress Text"}
        widgetType={widgetType}
        xs={3}
      />
    </Grid>
  );
};
